import { AlignmentType, Header, ImageRun, Paragraph, Table, TableCell, TableRow } from 'docx'

class BaseHeader {
  constructor(leftLogoImgBuffer, rightLogoImgBuffer) {
    return new Header({
      children: [
        new Table({
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new ImageRun({
                          data: leftLogoImgBuffer,
                          type: 'png',
                          transformation: { width: 253, height: 74 },
                        }),
                      ],
                      alignment: AlignmentType.START,
                    }),
                  ],
                  verticalAlign: 'center',
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new ImageRun({
                          data: rightLogoImgBuffer,
                          type: 'png',
                          transformation: { width: 207, height: 55 },
                        }),
                      ],
                      alignment: AlignmentType.END,
                    }),
                  ],
                  verticalAlign: 'center',
                }),
              ],
            }),
          ],
          width: {
            size: 100,
            type: 'pct',
          },
          borders: {
            top: { style: 'none', size: 0, color: 'FFFFFF' },
            bottom: { style: 'none', size: 0, color: 'FFFFFF' },
            left: { style: 'none', size: 0, color: 'FFFFFF' },
            right: { style: 'none', size: 0, color: 'FFFFFF' },
            insideHorizontal: { style: 'none', size: 0, color: 'FFFFFF' },
            insideVertical: { style: 'none', size: 0, color: 'FFFFFF' },
          },
        }),
      ],
    })
  }
}

export default BaseHeader
